import { FormattedMessage } from 'react-intl';
import { Facility } from '@/features/accounts/types';

interface Props {
  facilities: Facility[] | null;
  emptyMessageId?: string;
}

export default function FacilityList({ facilities, emptyMessageId = 'schedule.activate.facilitiesAny' }: Props) {
  if (!facilities || facilities.length === 0) {
    return <FormattedMessage id={emptyMessageId} />;
  }

  return <>{facilities.map((f) => f.name).join(', ')}</>;
}
